/**
 * Route Helper Functions
 * 
 * Utility functions to help with routing logic, especially for
 * determining which routes should be excluded from automatic redirects.
 */

/**
 * Check if the current path should be excluded from automatic redirects
 * (e.g., technical pages, modern layout routes, etc.)
 * 
 * @param {string} pathname - The current pathname (defaults to window.location.pathname)
 * @returns {boolean} - True if the path should be excluded from redirects
 */
export const shouldExcludeFromRedirect = (pathname = window.location.pathname) => {
  const excludedPaths = [
    '/TechnicalPage',
    '/technical',
    '/heat-profile',
    '/DCALGenerator',
    '/coil-configurator',
    '/projects',
    '/dashboard',
    '/dpr',
    '/calibration',
    '/AskEvans',
  ];

  const shouldExclude = excludedPaths.some((excludedPath) => pathname.startsWith(excludedPath));

  // Debug logging
  console.log('[RouteHelper] Checking path:', pathname, 'shouldExclude:', shouldExclude);

  return shouldExclude;
};

/**
 * Check if a path uses ModernLayout
 * 
 * @param {string} pathname - The pathname to check
 * @param {Array} routes - The routes array from routes.js
 * @returns {boolean} - True if the path uses ModernLayout
 */
export const isModernLayoutRoute = (pathname, routes) => {
  return routes.some(
    (route) =>
      route.layout?.name === 'ModernLayout' &&
      (route.exact ? pathname === route.path : pathname.startsWith(route.path))
  );
};
